import React, { FC, useMemo, useRef } from "react";
import { MuiBox, MuiTable } from "../../../../components";
import { addTopicSiteCoreKeys } from "../../../mdmAddTopic/siteCore/SiteCoreKeys";
import { UnitTypesKey } from "../../../../helpers/constants/siteCoreKeys";
import { AddExceptionsType } from "../../modelsAndSchemas/models";
import { useSiteCore } from "../../../../hooks/useSiteCore";
import { isMeasurementMinutes } from "../../../../helpers/utils";

interface ExceptionDetailsProps {
  pageId: string;
  selectedUnit: string;
  exceptionData: AddExceptionsType[];
}
const ExceptionDetails: FC<ExceptionDetailsProps> = ({
  pageId,
  selectedUnit,
  exceptionData,
}) => {
  const tableRef = useRef<{ resetPagination: () => void }>(null);
  const { commonLabels, fetchLabel, fetchValueByKeyOfDropdown } = useSiteCore();

  const {
    addTopic,
    minutesList,
    minutesLabel,
    quantityLabel,
    numberOfDaysLabel,
    countryLabel,
    noExceptionsFoundMessage,
  } = addTopicSiteCoreKeys;

  const getViewTopicLabel = (key: string) => {
    return fetchLabel(addTopic, key);
  };

  const measurementOtherLabel =
    selectedUnit === UnitTypesKey.Count ? quantityLabel : numberOfDaysLabel;

  const measurementLabel = isMeasurementMinutes(selectedUnit)
    ? getViewTopicLabel(minutesLabel)
    : getViewTopicLabel(measurementOtherLabel);

  const columns = [
    {
      id: "countryTitle",
      label: getViewTopicLabel(countryLabel),
      isSortVisible: true,
      className: "cell-country",
    },
    {
      id: "measurement",
      label: measurementLabel,
      isSortVisible: true,
      className: "cell-measurement",
    },
  ];

  const defaultValueExceptions = useMemo(() => {
    return Array.isArray(exceptionData) && exceptionData.length > 0
      ? exceptionData.map((item) => ({
          countryTitle: item.countryTitle,
          measurement: isMeasurementMinutes(item.unit)
            ? Number(
                fetchValueByKeyOfDropdown(
                  addTopic,
                  minutesList,
                  item.measurement,
                ),
              )
            : Number(item.measurement),
        }))
      : [];
  }, [exceptionData]);

  return (
    <MuiBox
      className="exception-container"
      data-testid={`${pageId}-exception-container`}
    >
      <MuiTable
        ref={tableRef}
        pageId={pageId}
        columns={columns}
        tableResults={defaultValueExceptions}
        noDataInApi={defaultValueExceptions.length === 0}
        emptyMessage={getViewTopicLabel(noExceptionsFoundMessage)}
        noResultMessage={commonLabels.noResult}
        tableHeaderForm={[]}
        footerColSpan={1}
        priorityResults={[]}
      />
    </MuiBox>
  );
};

export default ExceptionDetails;
